import { render, staticRenderFns } from "./RoomsArrangementDetailPage.vue?vue&type=template&id=743e52fd&scoped=true&"
import script from "./RoomsArrangementDetailPage.vue?vue&type=script&lang=ts&"
export * from "./RoomsArrangementDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743e52fd",
  null
  
)

export default component.exports